// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","443":"about"}[chunkId] || chunkId) + "." + {"167":"a198c9c1","201":"da9d786c","443":"8d0329b1"}[chunkId] + ".js";
};